import { Grid, Typography, Box, Card, CardContent, Stack, Container } from '@mui/material';
import ContactForm from 'features/contact/components/forms/ContactForm';
import SEO from 'features/shared/components/common/SEO';
import { site } from 'config/site';
import { pageSEO } from 'config/seo';
import EmailIcon from '@mui/icons-material/EmailOutlined';
import PhoneIcon from '@mui/icons-material/PhoneOutlined';
import LocationOnIcon from '@mui/icons-material/LocationOnOutlined';
import { motion } from 'framer-motion';

export default function Contacto(){
  return (
    <>
      <SEO 
        title={pageSEO.contacto.title}
        description={pageSEO.contacto.description}
      />

      <Container maxWidth="lg" sx={{ my: { xs: 6, md: 10 } }}>
        <motion.div
           initial={{ opacity: 0, y: 20 }}
           animate={{ opacity: 1, y: 0 }}
           transition={{ duration: 0.6 }}
        >
          <Typography variant="h3" sx={{ mb: 6, fontWeight: 800, fontSize: { xs: '2.5rem', md: '3.5rem' } }}>
            Ponte en <span className="text-gradient">Contacto</span>
          </Typography>
        </motion.div>

        <Grid container spacing={6}>
          <Grid item xs={12} md={7}>
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <Card elevation={0} sx={{ 
                p: { xs: 2, md: 4 }, 
                background: 'var(--glass-bg)',
                backdropFilter: 'blur(12px)',
                border: '1px solid var(--glass-border)',
                borderRadius: '24px'
              }}>
                <ContactForm />
              </Card>
            </motion.div>
          </Grid>

          <Grid item xs={12} md={5}>
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              style={{ height: '100%' }}
            >
              <Card elevation={0} sx={{ 
                border: '1px solid var(--glass-border)', 
                height: '100%',
                background: 'var(--glass-bg)',
                backdropFilter: 'blur(12px)',
                borderRadius: '24px'
              }}>
                <CardContent sx={{ p: { xs: 3, md: 4 } }}>
                  <Typography variant="h5" sx={{ mb: 4, fontWeight: 700, color: '#F8FAFC' }}>
                    Información Directa
                  </Typography>

                  <Stack spacing={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                      <Box sx={{ 
                        p: 1.5, 
                        borderRadius: '12px', 
                        background: 'rgba(59,130,246,0.1)',
                        color: '#60A5FA'
                      }}>
                        <EmailIcon fontSize="large" />
                      </Box>
                      <Box>
                        <Typography variant="body2" sx={{ color: '#94A3B8', mb: 0.5 }}>Email</Typography>
                        <Typography variant="body1" sx={{ fontWeight: 600, color: '#F8FAFC' }}>{site.contact.email}</Typography>
                      </Box>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                      <Box sx={{ 
                        p: 1.5, 
                        borderRadius: '12px', 
                        background: 'rgba(59,130,246,0.1)',
                        color: '#60A5FA'
                      }}>
                        <PhoneIcon fontSize="large" />
                      </Box>
                      <Box>
                        <Typography variant="body2" sx={{ color: '#94A3B8', mb: 0.5 }}>WhatsApp</Typography>
                        <Typography 
                          component="a" 
                          href={site.whatsapp.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          variant="body1" 
                          sx={{ 
                            fontWeight: 600, 
                            color: '#F8FAFC', 
                            textDecoration: 'none',
                            '&:hover': { color: '#60A5FA', textDecoration: 'underline' }
                          }}
                        >
                          {site.whatsapp.number}
                        </Typography>
                      </Box>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                      <Box sx={{ 
                        p: 1.5, 
                        borderRadius: '12px', 
                        background: 'rgba(59,130,246,0.1)',
                        color: '#60A5FA'
                      }}>
                        <LocationOnIcon fontSize="large" />
                      </Box>
                      <Box>
                        <Typography variant="body2" sx={{ color: '#94A3B8', mb: 0.5 }}>Ubicación</Typography>
                        <Typography variant="body1" sx={{ fontWeight: 600, color: '#F8FAFC' }}>{site.address.city}, {site.address.country}</Typography>
                      </Box>
                    </Box>
                  </Stack>

                  <Box sx={{ 
                    mt: 5, 
                    p: 3, 
                    background: 'linear-gradient(135deg, rgba(59,130,246,0.1) 0%, rgba(139,92,246,0.1) 100%)', 
                    borderRadius: '16px',
                    border: '1px solid rgba(255,255,255,0.05)'
                  }}>
                    <Typography variant="subtitle2" sx={{ color: '#F8FAFC', mb: 1, fontWeight: 700 }}>
                      Horarios de atención
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#94A3B8', mb: 0.5 }}>
                      Lunes a Viernes: 9:00 AM - 6:00 PM
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#94A3B8' }}>
                      Sábados: 9:00 AM - 2:00 PM
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}